import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'host-empty',
    templateUrl: './empty.component.html',
    styles: [':host {width:100%}']
})
export class EmptyComponent implements OnInit {

    message: string = "";

    constructor(private route: ActivatedRoute,
        private translate: TranslateService ) {
    }

    ngOnInit(){
        if (!!this.route.snapshot.data['message']) {
            this.message = this.translate.instant(this.route.snapshot.data['message']);
        }
    }
}
